<!-- eslint-disable max-len -->
<!--- Formulario FrmExpeditionMarina ---->
<!---
Descripción del componente y comportamiento:
---------------------------
-

Eventos escuchados por el formulario:
-----------------------

Eventos generados por el formulario:
-----------------------
-  XXXXXXX ->
--->

<template>
  <f7-page class="main-frm-expedition-edit-lines">
    <f7-navbar :style="appTheme">
      <f7-nav-left>
        <f7-link
          icon="icon-custom-back"
          class="padding-left"
          @click="goBack"
        />
        <div
          v-if="!editable"
          class="title color-white"
        >
          {{ $t('commercialization.common.newExpedition') }}
        </div>
        <div
          v-else
          class="title color-white"
        >
          {{ $t('commercialization.common.addLinesToExpedition') }}
        </div>
      </f7-nav-left>
    </f7-navbar>
    <div>
      <div class="div-new-lines">
        <div class="content-search padding-horizontal padding-vertical-half">
          <UCSearchEntityERP
            ref="UCOrderLine"
            :key="orderKey"
            :title="$t('searchEntity.salesOrderLine.title.salesOrderLine')"
            :placeholder="$t('searchEntity.salesOrderLine.placeholder.searchALine')"
            :search-text="$t('searchEntity.salesOrderLine.searchText')"
            :search-cancellation-text="$t('searchEntity.salesOrderLine.searchCancellationText')"
            :search-not-found-text="$t('searchEntity.salesOrderLine.searchNotFoundText')"
            :end-point-for-list="GetSalesOrder"
            :end-point-for-code-search="GetSalesOrderByFilter"
            :property-entity-shown-input="['LineaPedidoVenta.PedidoVenta.Serie', 'LineaPedidoVenta.PedidoVenta.Numero', 'LineaPedidoVenta.Orden']"
            :property-entity-shown-list-title="['LineaPedidoVenta.PedidoVenta.Serie', 'LineaPedidoVenta.PedidoVenta.Numero', 'LineaPedidoVenta.Orden']"
            :property-entity-shown-list-subtitle="['LineaPedidoVenta.PedidoVenta.Cliente.Nombre', 'LineaPedidoVenta.InfoProducto.Nombre', 'LineaPedidoVenta.PedidoVenta.FechaSalida', 'LineaPedidoVenta.PedidoVenta.Referencia', 'LineaPedidoVenta.PedidoVenta.NombreTransportista']"
            :pre-property-entity-shown-list-subtitle="[
              `${$t('common.customer')}: `,
              `${$t('common.product')}: `,
              `${$t('common.departureDateShort')}: `,
              `${$t('common.reference')}: `,
              `${$t('common.carrierName')}: `,
            ]"
            :min-text-search="0"
            :autofocus-on-deselection="true"
            :auto-focus-on-empty-search-result="true"
            :qr-search-show="true"
            :search-in="['.item-title', '.subtitle0', '.subtitle1', '.subtitle2', '.subtitle3', '.subtitle4']"
            :qr-search-params="{
              showInputButton: true,
              fabButtonShow: false,
              allowManualCodeEntry: true,
              barcodeSearchPrefix: 'Id:',
            }"
            :multi-selection="true"
            @selection="EventLineSelected"
            @selected-elements="EventMultiSelection"
          >
            <template #subtitle-2="{ item }">
              <div class="div_Fecha-Ref">
                {{ `${$t('common.departureDateShort')}:` }} <span class="span_Fecha-Ref"> {{ FormatDate(item, 'DD/MM/YYYY') }}</span>
              </div>
            </template>
            <template #subtitle-3="{ item }">
              <div class="div_Fecha-Ref">
                {{ `${$t('common.reference')}:` }} <span class="span_Fecha-Ref">{{ item }}</span>
              </div>
            </template>
            <template #subtitle-4="{ item }">
              <div class="div_Fecha-Ref">
                {{ `${$t('common.carrierName')}:` }} <span class="span_Fecha-Ref">{{ item }}</span>
              </div>
            </template>

            <template #footer="{ item }">
              <f7-row class="indicators">
                <!--
                <f7-col
                  width="33"
                  class="indicator-rectangle"
                >
                  <span class="span-valorInidicadorDePedido">

                  </span>
                  <span class="span-texto-gris-12-400">
                    {{ 'Palé Pend.' }}
                  </span>
                </f7-col>
              -->
                <f7-col
                  width="50"
                  class="indicator-rectangle"
                  :class="{ completed: item.CantidadPalesPaletizados >= item.CantidadPalesPendientes + item.CantidadPalesPaletizados }"
                >
                  <span class="number">
                    {{ `${(item.CantidadPalesPaletizados)} / ${(item.CantidadPalesPendientes + item.CantidadPalesPaletizados)}` }}
                  </span>
                  <span class="description">
                    {{ $t('commercialization.info.palletizedPallets') }}
                  </span>
                </f7-col>
                <f7-col
                  width="50"
                  class="indicator-rectangle"
                  :class="{ completed: item.CantidadPalesCargados >= item.CantidadPalesPendientes + item.CantidadPalesPaletizados }"
                >
                  <span class="number">
                    {{ `${item.CantidadPalesCargados} / ${(item.CantidadPalesPendientes + item.CantidadPalesPaletizados)}` }}
                  </span>

                  <span class="description">
                    {{ $t('commercialization.info.loadedPallets') }}
                  </span>
                </f7-col>
                <f7-col
                  width="50"
                  class="indicator-rectangle margin-top-half"
                  :class="{ completed: item.CantidadPalesReservados >= item.CantidadPalesPendientes + item.CantidadPalesPaletizados }"
                >
                  <span class="number">
                    {{ `${item.CantidadPalesReservados} / ${(item.CantidadPalesPendientes + item.CantidadPalesPaletizados)}` }}
                  </span>
                  <span class="description">
                    {{ $t('commercialization.info.reservedPallets') }}
                  </span>
                </f7-col>
                <f7-col
                  width="50"
                  class="indicator-rectangle margin-top-half"
                  :class="{ completed: item.CantidadPosicionesAsignadas + item.CantidadPalesReservados >= item.CantidadPalesPendientes + item.CantidadPalesPaletizados }"
                >
                  <span class="number">
                    {{ `${item.CantidadPosicionesAsignadas + item.CantidadPalesReservados} / ${(item.CantidadPalesPendientes + item.CantidadPalesPaletizados)}` }}
                  </span>
                  <span class="description">
                    {{ $t('commercialization.common.reservedPositions') }}
                  </span>
                </f7-col>
              </f7-row>
            </template>
          </UCSearchEntityERP>
          <div class="content-search__text">
            <img src="@/static/icons/vector.svg">
            <div>
              {{ $t('commercialization.common.searchSalesOrderLineOrScan') }}
            </div>
          </div>
        </div>
        <div class="content-list padding-top-half">
          <div
            v-for="(items, index) in linesSelected"
            :key="index"
            class="list inset accordion-list no-padding"
          >
            <ul>
              <li
                class="accordion-item"
                @accordion:beforeopen="GetReservedPallets(items.LineaPedidoVenta.Id)"
              >
                <a
                  class="item-content item-link no-padding no-chevron padding-half"
                  href="#"
                >
                  <div class="content-data">
                    <img
                      src="@/static/icons/ic_delete_02.svg"
                      @click="DeleteLine(items)"
                    >
                    <div class="content-data-info padding-horizontal-half">
                      <div class="content-data-info__title">
                        {{ `${items.LineaPedidoVenta.PedidoVenta.Serie}/${items.LineaPedidoVenta.PedidoVenta.Numero}-${items.LineaPedidoVenta.Orden} ${items.LineaPedidoVenta.PedidoVenta.Cliente.Nombre}` }}
                      </div>
                      <div class="content-data-info__subtitle">
                        {{ items.LineaPedidoVenta.InfoProducto.Nombre }}
                      </div>
                      <div class="content-data-info__text">
                        {{ `${items.LineaPedidoVenta.InfoEnvase.Nombre} ${items.LineaPedidoVenta.InfoPale.Nombre}` }}
                      </div>
                    </div>
                  </div>
                  <div class="content-pale">
                    <div class="content-pale__title">
                      {{ $t('common.pallets').toUpperCase() }}
                    </div>
                    <div class="content-pale__data"> {{ items.LineaPedidoVenta.CantidadPales }} </div>
                  </div>
                </a>

                <div
                  class="accordion-item-content"
                  :class="{ 'disabled-element': items.CantidadTotalPales === 0 }"
                >
                  <div class="content-info padding-horizontal-half">
                    <div class="content-total-pale">
                      <div class="content-total-pale__title">
                        {{ $t('commercialization.common.totalPendingPallets') }}
                      </div>
                      <div class="content-total-pale__data">
                        {{ items.CantidadTotalPales }} <!-- Palés disponibles no -->
                      </div>
                    </div>
                    <div class="content-stepper text-align-center">
                      <span>
                        {{ $t('common.quantity').toUpperCase() }}
                      </span>
                      <br>
                      <div
                        class="stepper stepper-fill stepper-init"
                      >
                        <f7-stepper
                          fill
                          :value="Number(items.CantidadTotalPales)"
                          :min="0"
                          :max="Number(items.CantidadTotalPales)"
                          @input="valorInput = $event.target.value"
                          @stepper:change="CambiarNumPales(items)"
                        />
                      </div>
                    </div>
                  </div>
                  <UCPreload
                    :number="1"
                    :show="showPreload"
                  />
                  <div
                    class="content-reserved-pallets"
                  >
                    <div
                      v-if="lstReservedPallets[items.LineaPedidoVenta.Id]"
                      style="margin-left: 40px; margin-bottom: 5px;"
                    >
                      <f7-button
                        class="content-reserved-pallets__button"
                        @click="EventSelectAllPaleXLine(items.LineaPedidoVenta.Id)"
                      >
                        {{ $t('common.selectAll') }}
                      </f7-button>
                    </div>
                    <div class="content-reserved-pallets">
                      <f7-list
                        v-for="(element, i) in lstReservedPallets[items.LineaPedidoVenta.Id]"
                        :key="i"
                        media-list
                        style="border: 1px solid rgb(235 236 240);"
                      >
                        <f7-list-item style="padding-left: 30px;">
                          <template #title>
                            <div>
                              <span v-if="element.ReservaExpedicion === null"> {{ element.UnidadContenedora.NumeroSerie }} </span>
                              <span
                                v-if="element.ReservaExpedicion !== null"
                                class="item-title1"
                              > {{ element.UnidadContenedora.NumeroSerie }} </span>
                            </div>
                          </template>

                          <template #subtitle>
                            <div
                              v-if="element.ReservaExpedicion !== null"
                              class="item-subtitle"
                            >
                              <span v-if="element.Cargada">
                                {{ `${$t('commercialization.common.loadedInLoadingOrder')} ${element.ReservaExpedicion.Serie} / ${element.ReservaExpedicion.Numero}` }}
                              </span>
                              <span v-else>
                                {{ `${$t('commercialization.common.reservedInLoadingOrder')} ${element.ReservaExpedicion.Serie} / ${element.ReservaExpedicion.Numero}` }}
                              </span>
                            </div>
                          </template>

                          <template #media>
                            <div
                              :class="{ 'disabled-element': element.ReservaExpedicion }"
                              @click="changeReservedPalletsToConfirm(element, items.LineaPedidoVenta.Id)"
                            >
                              <img
                                v-if="element.seleccionada === true"
                                :src="icCheckOn"
                                width="18"
                                height="18"
                              >
                              <img
                                v-else
                                :src="icCheckOff"
                                alt="iconCheckOff"
                                width="18"
                                height="18"
                              >
                            </div>
                          </template>
                        </f7-list-item>
                      </f7-list>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="!editable"
      class="content-button"
    >
      <f7-button
        small
        fill
        class="margin-horizontal"
        :class="{ disabled: (linesSelected.length === 0 || linesSelectedCheckCantidad) }"
        @click="NavigateToExpeditionDocumentMoreData()"
      >
        {{ $t('common.continue') }}
      </f7-button>
    </div>
    <div
      v-else
      class="content-button"
    >
      <f7-button
        small
        fill
        class="margin-horizontal margin-vertical-half"
        :class="{ disabled: (linesSelected.length === 0 || linesSelectedCheckCantidad) }"
        @click="NavigateToExpeditionDocument()"
      >
        {{ $t('commercialization.common.addLines') }}
      </f7-button>
    </div>
    <UCCodeScanner
      :fab-button-show="false"
    />
  </f7-page>
</template>

<script>
import { Log } from '@/js/common/HIDebuggingSupport';
import APIErp from '@/js/services/APIErp';
import UCPreload from '@/components/common/UCPreload.vue';
import icCheckOff from '@/static/icons/ic_checked_off.svg';
import UCSearchEntityERP from '@/components/common/UCSearchEntityERP.vue';
import icCheckOn from '@/static/icons/ic_check_on.svg';
import {
  HiDialog,
  HiNotification,
} from '@/js/common/HINotificationSupport';
import {
  HiDateTimeSupport,
} from '@/js/common/HIConversionSupport';
import UCCodeScanner from '@/components/common/UCCodeScanner.vue';
import { f7 } from 'framework7-vue';
import { sleep } from '@/js/utils/sleep';

export default {
  name: 'FrmExpeditionEditLines',

  components: {
    UCSearchEntityERP,
    UCPreload,
    UCCodeScanner,
  },

  props: {
    expeditionDocument: {
      type: Object,
      default: null,
    },
    editable: {
      type: Boolean,
      default: false,
    },
    clearDescgloses: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      expeditionDocumentSelected: null,
      showPreload: false,
      icCheckOn,
      icCheckOff,
      linesSelected: [],
      valorInput: 0,
      reservedPallet: null,
      lstReservedPallets: {}, // Contiene una asociación { idLineaPedido, [palesDisponiblesReservar]}
      pressDeleteLine: false,
      orderKey: 0,
      // lstReservedPalletsToConfirm: {},
    };
  },

  computed: {
    linesSelectedCheckCantidad() {
      // devolvemos true  si alguno de las lineas no tiene una cantidad de pales superior a 0
      let invalido = false;
      this.linesSelected.forEach((element) => {
        if (element.CantidadPales === 0) {
          invalido = true;
        }
      });
      return invalido;
    },

    appTheme() {
      return {
        '--f7-navbar-bg-color': 'var(--his-slate-blue)',
      };
    },
  },
  watch: {
    // whenever question changes
    expeditionDocument(newExpedition) {
      this.expeditionDocumentSelected = newExpedition;
    },
  },
  mounted() {
    if (this.clearDescgloses) {
      this.StartComponent();
      this.expeditionDocumentSelected.Lineas.forEach((element) => {
        element.CantidadPales = element.CantidadTotalPales;
        element.Desglose = [];
      });
      this.linesSelected = this.expeditionDocumentSelected.Lineas;
    }
  },
  created() {
    this.StartComponent();
  },
  methods: {
    StartComponent() {
      Log(this, this.StartComponent.name);
      if (this.expeditionDocument != null) {
        this.expeditionDocumentSelected = this.expeditionDocument;
      } else {
        this.expeditionDocumentSelected = {
          Serie: '',
          Numero: 0, // Nueva
          Conductor: null,
          EstadoOrdenCarga: 0,
          FechaSalida: null,
          Id: 0,
          Lineas: [],
          Matricula: null,
          Matricula2: null,
          Observaciones: null,
          TotalPales: 0,
          TotalPalesCargados: 0,
          Transportista: null,
          MuelleCarga: null,
          Dni: null,
          Temperatura: null,
        };
      }
    },
    goBack() {
      Log(this, this.goBack.name);
      f7.views.main.router.back();
    },
    async NavigateToExpeditionDocument() {
      Log(this, this.NavigateToExpeditionDocument.name);
      this.linesSelected.forEach((element) => {
        this.expeditionDocumentSelected.Lineas.push(element);
      });
      this.GenerateDesgloses();
      // Guardado de expedición
      const resultSave = await this.SaveExpedition(this.expeditionDocumentSelected);
      if (resultSave == null) {
        return;
      }
      // this.expeditionDocumentSelected = resultSave;
      f7.views.main.router.navigate('/commercialisation/expedition/frmExpeditionDocument/', {
        props: {
          expeditionDocument: this.expeditionDocumentSelected,
          reload: true,
        },
      });
    },

    NavigateToExpeditionDocumentMoreData() {
      Log(this, this.NavigateToExpeditionDocumentMoreData.name);
      this.expeditionDocumentSelected.Lineas = this.linesSelected;
      this.GenerateDesgloses();
      if (this.ValidateExpedition()) {
        f7.views.main.router.navigate('/commercialisation/expedition/frmExpeditionDocumentCompleteData/', {
          props: {
            expeditionDocument: this.expeditionDocumentSelected,
          },
        });
      } else {
        // Restablecemos los desgloses si no pasa la valiadación.
        this.expeditionDocumentSelected.Lineas.forEach((l) => {
          l.Desglose = [];
        });
      }
    },
    GenerateDesgloses() {
      Log(this, this.GenerateDesgloses.name);
      // 1º Generamos un Desglose por cada UL seleccionada de las reservas de la linea pedido venta.
      this.expeditionDocumentSelected.Lineas.forEach((l) => {
        if (Object.hasOwn(this.lstReservedPallets, l.LineaPedidoVenta.Id)) {
          this.lstReservedPallets[l.LineaPedidoVenta.Id].forEach((p) => {
            if (p.seleccionada) {
              l.Desglose.push({
                Estado: 0,
                Id: 0,
                UnidadContenedora: p.UnidadContenedora,
              });
            }
          });
        }
      });
      // 2º Generamos los desgloses lineas sin asignar reservas de palés segun el número total de palés
      this.expeditionDocumentSelected.Lineas.forEach((l) => {
        for (let index = l.Desglose.length; index < l.CantidadPales; index += 1) {
          l.Desglose.push({
            Estado: 0,
            Id: 0,
            UnidadContenedora: null,
          });
        }
      });
    },
    ValidateExpedition() {
      Log(this, this.ValidateExpedition.name);
      for (const i in this.expeditionDocumentSelected.Lineas) {
        if (this.expeditionDocumentSelected.Lineas[i].Desglose.length > this.expeditionDocumentSelected.Lineas[i].CantidadPales) {
          // HiNotification.Alert(`La cantidad de palés seleccionados para rerservar no puede ser superior que el disponible para asignar del pedido de venta ${this.expeditionDocumentSelected.Lineas[i].LineaPedidoVenta.PedidoVenta.Serie}/${this.expeditionDocumentSelected.Lineas[i].LineaPedidoVenta.PedidoVenta.Numero}`, this.$t('common.information'));
          const salesOrderText = `${this.expeditionDocumentSelected.Lineas[i].LineaPedidoVenta.PedidoVenta.Serie}/${this.expeditionDocumentSelected.Lineas[i].LineaPedidoVenta.PedidoVenta.Numero}`;
          HiNotification.Toast(this.$t('commercialization.info.palletsQuantityCannotBeHigherThanAvailable', { salesOrder: salesOrderText }));
          return false;
        }
      }
      return true;
    },

    DeleteLine(line) {
      Log(this, this.DeleteLine.name);
      this.pressDeleteLine = true;
      for (let i = 0; i < this.linesSelected.length; i += 1) {
        const e = this.linesSelected[i];
        if (e.LineaPedidoVenta.Id === line.LineaPedidoVenta.Id) {
          this.linesSelected.splice(i, 1);
        }
      }
    },

    Number(stringNumber) {
      return Number(stringNumber);
    },

    CambiarNumPales(items) {
      Log(this, this.CambiarNumPales.name);
      this.linesSelected.forEach((e) => {
        if (e.LineaPedidoVenta.Id === items.LineaPedidoVenta.Id) {
          e.CantidadPales = this.valorInput;
        }
      });
    },
    /*
    GetLines() {
      Log(this, this.GetLines.name);
      return APIErp.callSalesOrderLinesAvailableForExpedition();
    },
    */
    GetSalesOrder() {
      Log(this, this.GetSalesOrder.name);
      return APIErp.callSalesOrderLinesAvailableForExpedition();
    },
    GetSalesOrderByFilter(filter) {
      Log(this, this.GetSalesOrderByFilter.name);
      return APIErp.callSalesOrderLinesAvailableForExpedition(filter);
    },

    GetLengthObject(objeto) {
      Log(this, this.GetLengthObject.name);
      return Object.keys(objeto).length;
    },

    GetReservedPallets(idLineaPedidoVenta) {
      Log(this, this.GetReservedPallets.name);
      if (!this.pressDeleteLine) {
        this.Conections_GetReservedPalletsXSaleOrderLine(idLineaPedidoVenta);
      } else {
        this.pressDeleteLine = false;
      }
    },
    async resetOrderSelect() {
      Log(this, this.resetOrderSelect.name);
      await sleep(300);
      this.orderKey += 1;
    },
    EventMultiSelection(selectedItems) {
      Log(this, this.EventMultiSelection.name);
      if (selectedItems.length > 0) {
        selectedItems.forEach((element) => {
          const cantidadPendiente = element.LineaPedidoVenta.CantidadPales - (element.CantidadPosicionesAsignadas + element.CantidadPalesCargados + element.CantidadPalesReservados);
          let swag = true;
          const temp = {
            LineaPedidoVenta: element.LineaPedidoVenta,
            CantidadTotalPales: cantidadPendiente > 0 ? cantidadPendiente : 0,
            CantidadPales: element.LineaPedidoVenta.CantidadPales - (element.CantidadPosicionesAsignadas + element.CantidadPalesCargados + element.CantidadPalesReservados),
            Desglose: [],
          };
          const tempArray = [];
          tempArray.push(temp);

          this.linesSelected.forEach((l) => {
            if (l.LineaPedidoVenta.Id === temp.LineaPedidoVenta.Id) {
              swag = false;
            }
          });

          if (swag) {
            this.linesSelected.push(temp);
          }

          this.resetOrderSelect();
          // this.$refs.UCOrderLine.Clear();
        });
      } else {
        this.lineSelected = null;
      }
    },

    async EventLineSelected(objInfoLineExpedition) {
      Log(this, this.EventLineSelected.name);
      if (objInfoLineExpedition != null) {
        const cantidadPendiente = objInfoLineExpedition.LineaPedidoVenta.CantidadPales - (objInfoLineExpedition.CantidadPosicionesAsignadas + objInfoLineExpedition.CantidadPalesCargados + objInfoLineExpedition.CantidadPalesReservados);
        let swag = true;
        const temp = {
          LineaPedidoVenta: objInfoLineExpedition.LineaPedidoVenta,
          CantidadTotalPales: cantidadPendiente > 0 ? cantidadPendiente : 0,
          CantidadPales: objInfoLineExpedition.LineaPedidoVenta.CantidadPales - (objInfoLineExpedition.CantidadPosicionesAsignadas + objInfoLineExpedition.CantidadPalesCargados + objInfoLineExpedition.CantidadPalesReservados),
          Desglose: [],
        };
        const tempArray = [];
        tempArray.push(temp);

        this.linesSelected.forEach((l) => {
          if (l.LineaPedidoVenta.Id === temp.LineaPedidoVenta.Id) {
            swag = false;
          }
        });

        if (swag) {
          this.linesSelected.push(temp);
        }
        this.$refs.UCOrderLine.Clear();
      } else {
        this.lineSelected = null;
      }
    },

    EventSelectAllPaleXLine(idLineaPedidoVenta) {
      Log(this, this.EventSelectAllPaleXLine.name);
      const selectAll = this.lstReservedPallets[idLineaPedidoVenta].filter((e) => e.seleccionada).length === this.lstReservedPallets[idLineaPedidoVenta].length;
      this.lstReservedPallets[idLineaPedidoVenta].forEach((p) => {
        if (p.ReservaExpedicion === null) {
          p.seleccionada = !selectAll;
        }
      });

      /*
      for (const property in this.lstReservedPallets) {
        if (Object.hasOwnProperty.call(this.lstReservedPallets, property)) {
          if (property === `${idLineaPedidoVenta}`) {
            const element = this.lstReservedPallets[property];
            this.allSelect = !this.allSelect;
            element.forEach((p) => {
              p.seleccionada = this.allSelect;
            });
            if (this.allSelect) this.lstReservedPalletsToConfirm[property] = element;
            else delete this.lstReservedPalletsToConfirm[property];
          }
        }
      }
      */
    },

    changeReservedPalletsToConfirm(event, idLineaPedidoVenta) {
      Log(this, this.changeReservedPalletsToConfirm.name);
      this.lstReservedPallets[idLineaPedidoVenta].forEach((p) => {
        if (p.UnidadContenedora.Id === event.UnidadContenedora.Id) {
          p.seleccionada = !p.seleccionada;
          // if (p.seleccionada) this.lstReservedPalletsToConfirm[idLineaPedidoVenta] = element.filter((f) => f.seleccionada === true);
          // else delete this.lstReservedPalletsToConfirm[idLineaPedidoVenta];
        }
      });
    },
    FormatDate(stringDate, format) {
      return HiDateTimeSupport.FormatDateTime(
        stringDate,
        format,
      );
    },

    async Conections_GetReservedPalletsXSaleOrderLine(idLineaPedidoVenta) {
      Log(this, this.Conections_GetReservedPalletsXSaleOrderLine.name);
      this.showPreload = true;
      const result = await APIErp.callReservedSerialNumbersXSalesOrderLines(idLineaPedidoVenta);
      this.reservedPallet = result.data;
      this.reservedPallet.sort((a) => (a.ReservaExpedicion !== null ? 1 : -1)); // Los pales con reserva quedaran los ultimos en el listado.
      if (result.data.length > 0) {
        this.reservedPallet.forEach((e) => {
          e.seleccionada = false;
        });
        this.lstReservedPallets[`${idLineaPedidoVenta}`] = this.reservedPallet;
      }
      this.showPreload = false;
      return result;
    },
    async SaveExpedition(objExpedition) {
      HiDialog.Preloader(true, this.$t('commercialization.info.editingLoadingOrder'), false);
      try {
        const result = await APIErp.callSaveExpedition(objExpedition);
        HiDialog.Preloader(false);
        return result.data;
      } catch (error) {
        HiDialog.Preloader(false);
        HiNotification.Alert(error.response.data.Mensaje, this.$t('common.warning'));
        return null;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.main-frm-expedition-edit-lines {
  --available-viewport-height: calc(100vh - var(--information-bar-height));
  --information-bar-padding-bottom: 0;

  .page-content {
    background-color: var(--his-tierra-white);
  }

  .disabled-element {
    opacity: 0.5;
    pointer-events: none;
  }

  .icon-custom-back {
    background-image: url("@/static/icons/ic_back.svg");
    width: 24px;
    height: 24px;
  }

  .content-button {
    width: 100%;
    position: fixed;
    bottom: calc(8px + var(--information-bar-height));
    z-index: 2;
    background-color: var(--his-tierra-white);
    border-top: 0.5px solid #d8d8d8;
  }

  .div-new-lines {
    background-color: var(--his-tierra-white);

    .content-search {
      --f7-block-padding-horizontal: 8px;
      --f7-block-title-text-color: var(--his-oliva);

      border-bottom: 0.5px solid #d8d8d8;

      ::placeholder {
        color: var(--his-dark-blue);
        font-size: 16px;
        font-weight: 400;
      }

      .content-input input {
        padding-left: 14px;
      }

      .span-search {
        font-size: 12px;
      }

      &__text {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        color: var(--his-oliva);
        font-size: 12px;
        font-weight: 400;
        margin-top: 8px;

        img {
          margin-left: 5px;
          margin-right: 5px;
        }
      }
    }

    .content-list {
      background: var(--his-tierra-white);
      height: calc(var(--available-viewport-height) - 234px);
      overflow-y: scroll;

      .accordion-item {
        border-bottom: 0;
        border: 0.5px solid var(--his-silver);
        border-radius: 6px;
        margin-bottom: 10px;

        a {
          .content-data {
            display: flex;
            align-items: flex-start;
            justify-content: flex-start;

            .content-data-info {
              &__title {
                color: var(--his-slate-blue);
                font-size: 18px;
                font-weight: 400;
                line-height: 1.2;
                display: -webkit-box;
                white-space: normal;
                -webkit-line-clamp: 1;
                -webkit-box-orient: vertical;
                overflow: hidden;
                text-overflow: ellipsis;
              }

              &__subtitle {
                color: var(--his-oliva);
                font-weight: 400;
                font-size: 14px;
                line-height: 1.2;
                display: -webkit-box;
                white-space: normal;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                overflow: hidden;
                text-overflow: ellipsis;
              }

              &__text {
                color: var(--his-mandarina);
                font-weight: 400;
                font-size: 14px;
                margin-top: 5px;
                display: -webkit-box;
                white-space: normal;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                overflow: hidden;
                text-overflow: ellipsis;
              }
            }
          }

          .content-pale {
            height: 66px;
            width: 56px;
            min-width: 56px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 4px;
            flex-direction: column;
            background-color: var(--his-tierra-white);

            &__title {
              font-size: 10px;
              color: #aaa1a1;
              font-weight: 400;
              margin-top: 5px;
            }

            &__data {
              font-size: 30px;
              color: var(--his-slate-blue);
              font-weight: 400;
            }
          }
        }
      }

      .accordion-item-content {
        font-style: normal;
        font-weight: 400;
        font-size: 10px;
        line-height: 18px;
        color: var(--his-slate-blue);
        background: var(--hi-lightsnow);
        border-radius: 0 0 6px 6px;

        .content-info {
          display: flex;
          align-items: flex-start;
          justify-content: space-between;

          .content-total-pale {
            padding-left: 32px;
            padding-top: 5px;

            &__title {
              font-size: 10px;
              font-weight: 400;
            }

            &__data {
              font-size: 28px;
              font-weight: 400;
              color: var(--his-dark-blue);
              margin-top: 8px;
            }
          }

          .content-stepper {
            padding-top: 5px;
          }
        }

        .content-reserved-pallets {
          --f7-list-item-title-text-color: var(--his-slate-blue);
          --f7-list-item-media-margin: 0px;
          --f7-list-bg-color: var(--his-tierra-white);
          --f7-list-item-padding-horizontal: 8px;

          &__button {
            display: flex;
            width: fit-content;
            border: 1px solid var(--his-ash-gray);
            justify-content: flex-start;
            --f7-button-font-size: 10px;
            --f7-button-height: 26px;
          }

          .content-ckeckbox {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            padding-left: 8px;
            padding-bottom: 10px;

            span {
              padding-left: 20px;
              font-size: 14px;
              color: var(--his-slate-blue);
            }
          }
        }
      }
    }
  }

  .item-subtitle {
    color: var(--his-kiwi-pulp);
    font-weight: 400;
    font-size: 14px;
    line-height: 1.2;
    display: -webkit-box;
    white-space: normal;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .item-title1 {
    color: var(--his-dark-blue);
    font-weight: 400;
    font-size: 14px;
    line-height: 1.2;
    display: -webkit-box;
    white-space: normal;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .div_Fecha-Ref {
    font-size: 14px;
  }

  .span_Fecha-Ref {
    margin-left: 15px;
  }
}

/****  INICIO - Estilos del Popup de selección de LPV en el UCSearch ***/
.indicators {
  margin: 10px;

  .indicator-rectangle {
    background-color: rgb(247 248 250);
    display: grid;
    padding: 12px 2px 1px;
    text-align: center;
    border-radius: 10px;

    &.completed {
      background: rgb(102 186 51 / 19%);
    }

    span {
      &.description {
        color: var(--his-ash-gray);
        font-size: 12px;
        font-weight: 400;
        line-height: 16px;
      }

      &.number {
        color: var(--his-darkgray);
        font-size: 20px;
        font-weight: 400;
        line-height: 26px;
        text-align: center;
      }
    }
  }
}

/****  FIN - Estilos del Popup de selección de LPV en el UCSearch ***/
</style>
